<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu đăng ký MC ưu đãi</h1>
      <div class="float-right btn-group">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/preferential-merchant-registration/create')"
        >
          Tạo phiếu
        </button>

        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <!-- <button v-if="exportPermission" @click="exportExcel"
            class="font-medium f12 btn btn-outline-secondary">
            <i class='bx bx-download'></i> Xuất excel
          </button> -->
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              v-model.trim="search.keyword"
              type="text"
              placeholder="Email/tên/sđt/mã phiếu"
              style="border-radius: 4px"
              @keyup.enter.prevent="fetchData"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateCreate"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.creatorId" :options="listUser" placeholder="Người tạo" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleCS" :options="listUser" placeholder="Sale chăm sóc" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.saleRegionId"
              :options="dataConfigRegion"
              placeholder="Vùng kinh doanh"
              @change="queryProvince($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.saleProvinceId"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeOffer"
              :options="Config.getSearch(optionType)"
              placeholder="Loại ưu đãi"
            />
          </div>
          <div class="form-group">
            <!-- <Select2MultipleControl :settings="{ placeholder: 'Trạng thái', closeOnSelect: false }"
              v-model="search.status" :options="Config.getSearch(optionStatus)">
            </Select2MultipleControl> -->
            <Select2
              v-model="search.status"
              :options="Config.getSearch(optionStatus)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.additionalStatus"
              :options="Config.getSearch(optionAdditionalStatus)"
              placeholder="Trạng thái cam kết BS sau"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian cam kết
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group form-group-action">
            <button
              type="button"
              @click="fetchData()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ totalRows }}</strong>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(code)="data">
                <p>{{ data.item.code ? data.item.code : '' }}</p>
              </template>
              <template #cell(time)="data">
                <p v-if="data.item.createAt">
                  Tạo: {{ data.item.createAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.approvalTime">
                  Duyệt: {{ data.item.approvalTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.rejectionTime">
                  Từ chối: {{ data.item.rejectionTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.cancellationTime">
                  Huỷ: {{ data.item.cancellationTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(merchant)="data">
                <p>
                  {{
                    data.item.merchant && data.item.merchant.merchantName
                      ? data.item.merchant.merchantName
                      : ''
                  }}
                </p>
                <p>
                  {{
                    data.item.merchant && data.item.merchant.email ? data.item.merchant.email : ''
                  }}
                </p>
                <p>
                  sale cs: {{ data.item.user && data.item.user.email ? data.item.user.email : '' }}
                </p>
              </template>
              <template #cell(additional)="data">
                <p>
                  {{
                    data.item.additionalStatus
                      ? joinArrayData(data.item.additionalStatus, optionAdditionalStatus)
                      : ''
                  }}
                </p>
                <p v-if="data.item.additionalTime">
                  {{ data.item.additionalTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(type)="data">
                <p>
                  {{ data.item.typeOffer ? joinArrayData(data.item.typeOffer, optionType) : '' }}
                </p>
              </template>
              <template #cell(createdBy)="data">
                <p>{{ data.item.createByName ?? '' }}</p>
                <p>{{ data.item.createByEmail ?? '' }}</p>
              </template>
              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="data.item.status ? getColor(data.item.status, optionColorStatus) : ''"
                  >{{ data.item.status ? joinArrayData(data.item.status, optionStatus) : '' }}</span
                >
              </template>

              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="
                      $router.push(`/preferential-merchant-registration/detail/${data.item.id}`)
                    "
                  >
                    Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="
                      $router.push(`/preferential-merchant-registration/edit/${data.item.id}`)
                    "
                    v-if="optionStatusCanEdit.includes(data.item.status)"
                  >
                    Sửa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          @change="onChangePage"
          :total-rows="totalRows"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '../../../thirdParty/config'
  import { ContractService } from '@/services/contract.service'
  import cloneDeep from 'lodash/cloneDeep'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã phiếu', thStyle: 'min-width: 80px' },
    { key: 'time', label: 'Thời gian' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'additional', label: 'Cam kết bổ sung sau', thStyle: 'min-width: 280px' },
    { key: 'type', label: 'Loại ưu đãi' },
    { key: 'createdBy', label: 'Người tạo', thStyle: 'min-width: 120px' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Hành động', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        search: {
          limit: 15,
          page: 1,
        },
        totalRows: 0,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateCreate: {
          startDate: null,
          endDate: null,
        },
        showLoading: false,
        listUser: [],
        dataConfigRegion: [],
        dataProvince: [],
        loading: false,
        lists: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'AWAITING_MANAGER_APPROVAL', text: 'Chờ GĐV duyệt' },
          { id: 'MANAGER_REJECTED', text: 'Từ chối' },
          { id: 'MANAGER_REQUESTED_ADDITIONAL', text: 'GĐV YC Bổ sung' },
          { id: 'AWAITING_OPERATION_APPROVAL', text: 'Chờ VH duyệt' },
          { id: 'OPERATION_REQUESTED_EDIT', text: 'VH yêu cầu bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'VH đã duyệt' },
          { id: 'CANCELED', text: 'Đã huỷ' },
        ],
        optionType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_KEY_ONUS', text: 'Merchant key + onus' },
        ],
        optionAdditionalStatus: [
          { id: 'NO_ADDITIONAL_INFO_NEEDED', text: 'Không cần bổ sung' },
          { id: 'NEED_ADDITIONAL_INFO_LATER', text: 'Cần bổ sung sau' },
          { id: 'WAIT_APPROVE_ADDITION', text: 'Chờ duyệt bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'Đã đủ hồ sơ' },
        ],
        optionColorStatus: {
          NEW: 'success',
          AWAITING_MANAGER_APPROVAL: 'info',
          MANAGER_REJECTED: 'danger',
          MANAGER_REQUESTED_ADDITIONAL: 'danger',
          AWAITING_OPERATION_APPROVAL: 'info',
          OPERATION_REQUESTED_EDIT: 'danger',
          OPERATION_APPROVED: 'primary',
          CANCELED: 'danger',
        },
        optionStatusCanEdit: ['NEW', 'MANAGER_REQUESTED_ADDITIONAL', 'OPERATION_REQUESTED_EDIT'],
      }
    },
    watch: {},
    created() {
      this.fetchData()
      this.getRegions()
      this.getListStaffBySuperior()
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
    },
    methods: {
      clearSearch() {
        this.search = {
          page: 1,
          limit: 15,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateCreate = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []

        this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          this.formatData()
          const response = await ContractService.getListMerchantKeyOnus(this.search)
          if (response.code === 1000) {
            const mapData = response.data
            this.lists = mapData.data ? mapData.data : []
            this.totalRows =
              mapData.meta && mapData.meta.pagination && mapData.meta.pagination.total
                ? mapData.meta.pagination.total
                : 0
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.loading = false
        }
      },
      async formatData() {
        if (this.dateRange.endDate) {
          this.search.additionalTimeTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours')
        } else delete this.search.additionalTimeTo
        if (this.dateRange.startDate) {
          this.search.additionalTimeFrom = moment(this.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
        } else delete this.search.additionalTimeFrom
        if (this.dateCreate.endDate) {
          this.search.createDateTo = moment(this.dateCreate.endDate).endOf('day').add(7, 'hours')
        } else delete this.search.createDateTo
        if (this.dateCreate.startDate) {
          this.search.createDateFrom = moment(this.dateCreate.startDate)
            .startOf('day')
            .add(7, 'hours')
        } else delete this.search.createDateFrom

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
      },
      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = [
            {
              id: 0,
              text: 'Tất cả',
            },
          ]
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },
      async queryProvince(e) {
        try {
          this.search.saleProvinceId = '0'
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            const dataProvince = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.code,
                text: e.name,
              }
              dataProvince.push(body)
            })
            this.dataProvince = dataProvince
            return
          }
          this.dataProvince = []
        } catch (error) {}
      },
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            const dataUser = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
              dataUser.push(body)
            })
            this.listUser = dataUser
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
    },
  }
</script>
<style>
  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }

    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }

    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }
  .success {
    color: #fff;
    background-color: #28a745;
  }
  .info {
    color: #fff;
    background-color: #117a8b;
  }
  .danger {
    color: #fff;
    background-color: #dc3545;
  }
  .primary {
    color: #fff;
    background-color: #007bff;
  }
</style>
